import React, { useState, useRef, useEffect } from "react";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import useAxios from "../../utils/useAxios";
import { toast } from "react-toastify";

const AccessMenu = ({ u, endpoint, setSharedUsers }) => {
    const { t } = useTranslation();
    const api = useAxios();
    const [open, setOpen] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const close = e =>
            ref.current && !ref.current.contains(e.target) && setOpen(false);
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    const changeAccess = async (write) => {
        try {
            await api.patch(`${endpoint}${u.id}/`, { write });
            setSharedUsers(prev =>
                prev.map(su =>
                    su.id === u.id ? { ...su, write } : su
                )
            );
            toast.success(t("Access updated"));
            setOpen(false);
        } catch {
            toast.error(t("Failed to update"));
        }
    };

    const deleteAccess = async () => {
        if (!window.confirm(t("Are you sure you want to remove access?"))) return;

        try {
            await api.delete(`${endpoint}${u.id}/`);
            setSharedUsers(prev => prev.filter(su => su.id !== u.id));
            toast.success(t("Access removed"));
            setOpen(false);
        } catch {
            toast.error(t("Failed to remove"));
        }
    };

    return (
        <div ref={ref} style={{ position: "relative" }}>
            <div className="options dots_menu" onClick={() => setOpen(v => !v)}>
                <FeatherIcon icon="more-vertical" />
            </div>

            {open && (
                <div className="dropdown-menu block_active access-menu">
                    <ul>
                        <li
                            className={!u.write ? "active" : ""}
                            onClick={() => changeAccess(false)}
                        >
                            <FeatherIcon icon="eye" />
                            {t("View access")}
                        </li>

                        <li
                            className={u.write ? "active" : ""}
                            onClick={() => changeAccess(true)}
                        >
                            <FeatherIcon icon="edit" />
                            {t("Full access")}
                        </li>

                        <li className="danger" onClick={deleteAccess}>
                            <FeatherIcon icon="trash-2" />
                            {t("Delete")}
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default AccessMenu;
